<div class="pad-L primary">
	<div style="max-height: calc(80vh - 256px); min-height: calc(80vh - 256px); overflow: auto">
		<div class="flex-align-center gap-S f-d-r mb-m">
			<app-chips [square]="true" [size]="'xl'">
				<img src="assets/icons/layers-three-02.svg" class="filter-grey" height="25px">
			</app-chips>
			<div class="flex-column gap-XS ml-s">
				<div class="font-L fw-700">{{ 'page.appDetails.overview.functionalCapacities.add' | translate }}</div>
				<div class="font-M fw-300">{{ 'page.appDetails.overview.functionalCapacities.addSubtitle' | translate }}</div>
			</div>
		</div>

		<div class="flex-column gap-L">
			<form class="flex-column gap-L" [formGroup]="createFunctionalCapacityGroupFormGroup">
				<div class="flex-column gap-S flex-center">
					<div class="selected-icon-container flex-center">
						<img width="30" [src]="'assets/icons/functional-capacities/' + createFunctionalCapacityGroupFormGroup.get('icon')!.value + '.svg'" class="filter-accent" alt=""/>
					</div>
					<span class="grey text-underline c-p" (click)="showIcons = !showIcons">{{ 'page.appDetails.overview.functionalCapacities.changeIcon' | translate }}</span>
					<div class="icon-selection-container" *ngIf="showIcons" style="padding: 10px 15px;">
						<div *ngFor="let icon of icons" class="func-icon-btn flex-center c-p" [class.icon-selected]="icon === createFunctionalCapacityGroupFormGroup.get('icon')!.value " (click)="createFunctionalCapacityGroupFormGroup.get('icon')!.setValue(icon)">
							<img width="20" [src]="'assets/icons/functional-capacities/' + icon + '.svg'" class="filter-accent" alt=""/>
						</div>
					</div>
				</div>
				<div class="flex-column gap-XS overflow-hidden">
					<div class="font-M fw-500 grey">{{ 'page.appDetails.overview.functionalCapacities.groupName' | translate }}*</div>
					<app-text-input [input]="$any(createFunctionalCapacityGroupFormGroup.get('name'))"
									[placeholder]="'page.appDetails.overview.functionalCapacities.nameInput' | translate"></app-text-input>
				</div>
			</form>
		</div>
	</div>

	<div class="w-100 disp-f f-d-r j-c-sb a-i-c mt-l gap-M ">
		<app-text-button class="w-50" type="stroked" (click)="onCancel()">
			{{ 'page.appDetails.overview.functionalCapacities.back' | translate }}
		</app-text-button>
		<app-text-button class="w-50" type="flat" (click)="onSave()" [disabled]="!createFunctionalCapacityGroupFormGroup.valid">
			{{ 'button.save' | translate }}
		</app-text-button>
	</div>
</div>
